// The WGSL twin of `../survey.ts` (R2626).
//
// The same picture from the same figures: read the cell, and paint the veil
// and the hatch where the survey holds no texel. The plane tap is
// `textureLoad`, and the `inGrid` guard stays an `if`, because `select`
// evaluates both arms.

import { SURVEY_ALL_UNIFORMS } from '../survey';
import { PRELUDE_BODY_WGSL } from './prelude';
import { wgslModule } from './module';

const SURVEY_FRAG_WGSL = `
// A cell outside the grid is no water of the survey, so it draws nothing.
fn surveyedOf(c: vec2i) -> f32 {
  if (!inGrid(c)) { return 1.0; }
  return f32(textureLoad(uSurvey, c, 0).r);
}

@fragment fn fs(v: VsOut) -> @location(0) vec4f {
  let p = v.vWorld;
  let c = cellAt(p);
  if (surveyedOf(c) > 0.5) { return vec4f(0.0); }

  let px = worldPx();
  // The lines run at 45 degrees: the distance along their normal.
  let t = (p.x + p.y) * 0.7071067811865476;
  let d = abs(fract(t / U.uSvSpacing + 0.5) - 0.5) * U.uSvSpacing;
  let cov = lineCov(d, 0.5 * U.uSvLinePx * U.uDpr * px, px);
  let apart = U.uSvSpacing * U.uZoom;
  var fade = 1.0;
  if (U.uSvFadePx > 0.0) { fade = clamp((apart - U.uSvFadePx) / U.uSvFadePx, 0.0, 1.0); }

  let o = vec4f(U.uSvVeil * U.uSvVeilAlpha, U.uSvVeilAlpha);
  return over(o, U.uSvInk, U.uSvLineAlpha * cov * fade);
}
`;

/** The whole survey module, for the parity suite. */
export function surveyProgramWgsl(): string {
  return wgslModule({ uniforms: SURVEY_ALL_UNIFORMS, body: surveyBodyWgsl() });
}

/** The survey's BODY: the shared prelude body and the fragment entry. */
export function surveyBodyWgsl(): string {
  return PRELUDE_BODY_WGSL + SURVEY_FRAG_WGSL;
}
